module.exports = __webpack_public_path__ + "img/thumbnail_Hippopotamus_m_albino.82a510d0.png";